import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, PlayIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function BonusSection() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="bonus-title" data-id="element-14" data-mp="22ebwf84sbiga">
      <div className="mx-auto max-w-6xl px-5" data-id="element-15" data-mp="1ydrulr99nqnt">
        <SectionHeading eyebrow="Siempre incluidos con tu MegaPack" title={<span id="bonus-title" data-id="element-17" data-mp="1aop4rw4hari8">Bonos estratégicos</span>} subtitle={<>
              2 bonos de regalo + 1 video masterclass —{' '}
              <span className="font-semibold text-gold-400" data-id="element-18" data-mp="1jh0uffrrqax5">valor total: $45.000 → GRATIS</span>
            </>} data-id="element-16" data-mp="1ybx9abu31wj7" />

        <ul className="mt-14 grid gap-5 lg:grid-cols-3" data-id="element-19" data-mp="1eohkqtw7bzxm">
          {bonuses.map((bonus, i) => <motion.li key={bonus.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08,
          ease: 'easeOut'
        }} className="flex flex-col gap-4 rounded-2xl border border-gold-500/25 bg-ink-800 p-6" data-id="element-20" data-mp="qywz238nyokn" data-mpi={i}>
              <div className="flex items-center gap-2" data-id="element-21" data-mp="2jieezpi7t6to">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gold-500/15" data-id="element-22" data-mp="2ohipcjgvlall">
                  {bonus.isVideo ? <PlayIcon className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-23" data-mp="1qv1udkvm7930" /> : <GiftIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-24" data-mp="1vu5077jf5jc1" />}
                </span>
                <span className="font-display text-sm uppercase tracking-[0.16em] text-gold-500" data-id="element-25" data-mp="25r10wr32t161">
                  {bonus.label}
                </span>
              </div>

              <h3 className="font-display text-lg uppercase leading-tight text-cream" data-id="element-26" data-mp="3c8wgim3aj04z">
                {bonus.title}
              </h3>
              <p className="text-sm leading-relaxed text-cream/65" data-id="element-27" data-mp="1h2m3vbjnvpyl">{bonus.text}</p>

              <div className="mt-auto flex items-center gap-3 pt-2" data-id="element-28" data-mp="1c4khagn118id">
                <span className="text-sm text-cream/40 line-through" data-id="element-29" data-mp="1c6exxir9megn">{bonus.price}</span>
                <span className="rounded-full bg-rose-600/20 px-3 py-1 text-xs font-bold uppercase tracking-wide text-rose-400" data-id="element-30" data-mp="1q3aerxdrda79">
                  {bonus.badge}
                </span>
              </div>
            </motion.li>)}
        </ul>

        <p className="mt-10 text-center text-sm text-cream/70" data-id="element-31" data-mp="tem0nc55y734">
          Valor total de los bonos{' '}
          <span className="text-cream/40 line-through" data-id="element-32" data-mp="175hbuv34x09v">$45.000</span>{' '}
          <span className="font-bold text-gold-400" data-id="element-33" data-mp="12er9zrtx3fjx">→ GRATIS con tu MegaPack</span>
        </p>
      </div>
    </section>;
}